import React from 'react'

import { Button, Container, Typography } from '@mui/joy'
import { useNavigate } from 'react-router-dom'

export function CancelPage() {
    const navigate = useNavigate()
    const handleSubmit = event => {
        event.preventDefault()
        navigate(`./confirm`)
    }
    return (
        <Container>
            <form method="POST" onSubmit={handleSubmit}>
                <Typography level="h1" element="h1">Cancel</Typography>
                <Typography>Are you sure you want to leave?</Typography>
                <Typography>On cancelation, your plan will run out until the end of it's billing period.</Typography>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                >Yes, cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(`../billing`)}
                >
                    No, take me back
                </Button>
            </form>
            
        </Container>
    )
}